import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { FileManagementResponse } from '../interfaces/interfaces';

@Injectable({
  providedIn: 'root'
})
export class FileManagementService {
  private baseUrl: string;

  constructor(private http: HttpClient) {
    this.baseUrl = environment.apiSite.endsWith('/') 
      ? environment.apiSite.slice(0, -1) 
      : environment.apiSite;
  }

  getFileManagement(path: string = ''): Observable<FileManagementResponse> {
    const url = `${this.baseUrl}/FileManagement`;
    const params = path ? { path } : {};
    return this.http.get<FileManagementResponse>(url, { params });
  }

  createDirectory(directoryPath: string): Observable<any> {
    return this.http.post(`${this.baseUrl}/CreateDirectory`, {
      directoryPath: directoryPath
    });
  }

  uploadToDirectory(file: File, directoryPath: string, description: string = '', overwrite: boolean = false): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('directoryPath', directoryPath);
    formData.append('description', description);
    formData.append('overwrite', overwrite.toString());

    return this.http.post(`${this.baseUrl}/UploadToDirectory`, formData);
  }

  downloadFile(filePath: string): Observable<Blob> {
    const url = `${this.baseUrl}/Download`;
    return this.http.get(`${url}?filePath=${encodeURIComponent(filePath)}`, {
      responseType: 'blob'
    });
  }

  deleteFile(filePath: string): Observable<any> {
    const url = `${this.baseUrl}/DeleteFile`;
    return this.http.delete(url, {
      params: { filePath }
    });
  }
} 